import api from '../../../api';
import * as unassignChat from '../../../modules/trader-chat/actions/unassign-chat';

export function request(dispatch, { chatId }) {
    api.post('/chats/' + chatId + '/unassign').then(
        () => dispatch(unassignChat.finish(chatId)),
        (data) => dispatch(unassignChat.error(chatId, data.errors))
    );
}

